import OrderedPageFilter from '../../../commons/orderedPageFilter'
import { adminHttpClient } from '../../../commons/adminHttpClient'
import PagedList from '../../../commons/pagedList'

export enum ExpenseStatus {
  AwaitingReview = 0,
  Verified = 1,
  ActionRequired = 2,
  Ineligible = 3,
  PerksAwaitingReview = 4,
}

export type ReimbursementTransactionResponse = {
  expenseNumber: number
  status: ExpenseStatus
  firstName: string
  lastName: string
  amount: number
  submissionDate: string
  approvedDate?: string
  scheduledDate?: string
}

export type ReimbursementTransactionsFilter = OrderedPageFilter & {
  fromDate?: string
  toDate?: string
}

export const getReimbursementTransactions = (
  planPeriodId: string,
  filter: ReimbursementTransactionsFilter,
): Promise<PagedList<ReimbursementTransactionResponse>> => {
  return adminHttpClient.get(`/AdminDashboard/ReimbursementsTransaction/${planPeriodId}/ReimbursementTransaction`, {
    ...filter,
  })
}

export const getReimbursementTransactionsForCsv = async (
  planPeriodId: string,
  filter: ReimbursementTransactionsFilter,
) => {
  return await adminHttpClient.get(`/AdminDashboard/ReimbursementsTransaction/${planPeriodId}/CSV`, {
    ...filter,
  })
}
